import React from "react";

const DetailPanel = ({ children }) => {
  return <div>{children}</div>;
};

export default DetailPanel;
